module.exports = __webpack_public_path__ + "static/img/7.dad4e33.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/7.png
// module id = 54VI
// module chunks = 0